/** SiteAdmin/SubtypedTable */
define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"SiteAdmin/SubtypedViewMixin"
], function(declare,TableWidget,SubtypedViewMixin) {

	return declare([TableWidget, SubtypedViewMixin], {
	});
});